/* eslint-disable import/prefer-default-export */
export const postCodeUserSelectedType = {
    /** 도로명 선택 시 */
    R: 'R',
    /** 지번 선택 시 */
    J: 'J',
};
